var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { fontSizes } from 'syf-component-library/defaultTheme';
export var SuperscriptContainer = styled.sup(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n  vertical-align: super;\n"], ["\n  font-size: ", "px;\n  vertical-align: super;\n"])), fontSizes.small);
export var CrossContainer = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: system-ui;\n  display: contents;\n"], ["\n  font-family: system-ui;\n  display: contents;\n"])));
var formatCharToSuperscript = function (name, separatorRegex, superscriptChars) {
    var textSegments = name.split(separatorRegex);
    return (_jsx(_Fragment, { children: textSegments.map(function (segment) {
            if (segment === '†') {
                return _jsx(CrossContainer, { children: segment }, segment);
            }
            if (superscriptChars.includes(segment)) {
                return (_jsx(SuperscriptContainer, { children: segment }, segment));
            }
            return segment;
        }) }));
};
export default formatCharToSuperscript;
var templateObject_1, templateObject_2;
